module.exports = "/fonts/vendor/boxicons/boxicons.woff2?aab73283f839e775f9ac86d642983653";